module.exports = __webpack_public_path__ + "media/images/new-ui-images/appointment-ed675d9c35f9443ac2e9d21ab505a8bb.svg";